import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { dashboard as spDashboard } from '@cred/react-analytics/contexts'
import Font from '@cred/react-font'
import { Testable } from '@cred/react-testable'
import emptyList from 'mortgage-combined/assets/emptyList.svg'
import FullDashboard from './full-dashboard'
import ShortDashboard from './short-dashboard'
import { ErrorNoOffers } from '../error-pages'
import { getSnowplowFilter } from '../common/utils'
import styles from './styles.scss'
import { MORTGAGE_FILTER_FORM_NAME, MORTGAGE_SORTING_FORM_NAME } from '../common/constants'

const Dashboard = ({
  isFullTable,
  loading,
  products,
  onGetStarted,
  error,
  analyticsContexts = [],
  formData,
  sorting,
  term,
  isMultiVertical,
  multiVerticalVariation,
  paginationProps,
}) => {
  if (loading) {
    return <div className={styles.spinner} />
  }

  const filter = getSnowplowFilter(formData, term),
    dashboardContexts = [
      ...analyticsContexts,
      spDashboard.analytics({ filter, sort: sorting, smartFilter: false }),
    ]

  const getContent = () => {
    if (error || !products.length) {
      return (
        <div className={styles.noOffers}>
          <img className={`${styles.emptyIcon} mb-48`} src={emptyList} alt="no-offers" />
          <Font type="medium" weight="bold" className="mb-16">
            We couldn’t find any loans matching your criteria
          </Font>
          <ErrorNoOffers error={error} />
        </div>
      )
    }

    if (isFullTable) {
      return (
        <FullDashboard
          formData={formData}
          products={products}
          paginationProps={paginationProps}
          onGetStarted={onGetStarted}
          dashboardContexts={dashboardContexts}
          isMultiVertical={isMultiVertical}
          multiVerticalVariation={multiVerticalVariation}
        />
      )
    }

    return (
      <ShortDashboard
        formData={formData}
        products={products}
        onGetStarted={onGetStarted}
        dashboardContexts={dashboardContexts}
      />
    )
  }

  return (
    <Testable
      className={`${styles.dashboardContainer} ${
        isMultiVertical ? 'multivertical-lenders-list' : styles.withBorders
      }`}
      testId="products-list"
    >
      {getContent()}
    </Testable>
  )
}

Dashboard.propTypes = {
  isFullTable: PropTypes.bool.isRequired,
  products: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onGetStarted: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  analyticsContexts: PropTypes.array,
  error: PropTypes.object,
  sorting: PropTypes.string,
  multiVerticalVariation: PropTypes.string,
  term: PropTypes.object,
  isMultiVertical: PropTypes.bool,
  paginationProps: PropTypes.object.isRequired,
}

const mapStateToProps = (state, { initialFormValues }) => {
  const filterFormData = state.form[MORTGAGE_FILTER_FORM_NAME],
    sortingFormData = state.form[MORTGAGE_SORTING_FORM_NAME],
    term = filterFormData && filterFormData.values ? filterFormData.values.term : {},
    defaultFormValues = initialFormValues ? { values: initialFormValues } : { values: {} },
    formData = filterFormData || defaultFormValues,
    sorting = sortingFormData ? sortingFormData.values.sorting : formData.values.sorting

  return {
    formData,
    sorting,
    term,
  }
}
const App = connect(mapStateToProps)(Dashboard)

export default App
